// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"SubOrganizationsList_blockClick_2K-4Z"};